<template>
  <div class="checklist-record-skeleton">
    <SkeletonAnimate class="skeleton circle" />
    <SkeletonAnimate class="skeleton title" />
    <SkeletonAnimate
      class="skeleton square"
      style="margin-left:24px"
    />
    <SkeletonAnimate class="skeleton square" />
    <SkeletonAnimate class="skeleton square" />
    <SkeletonAnimate class="skeleton square" />
    <SkeletonAnimate class="skeleton content" />
    <SkeletonAnimate
      class="skeleton content"
      style="margin-left:auto"
    />
  </div>
</template>
<script>
export default {
  name: "ChecklistRecordSkeleton",
};
</script>
<style lang="scss">
@import "@/assets/scss/component/checklist-record-skeleton";
</style>